import { render } from "./EditZone.vue?vue&type=template&id=06bc9820&scoped=true"
import script from "./EditZone.vue?vue&type=script&lang=js"
export * from "./EditZone.vue?vue&type=script&lang=js"

import "./EditZone.vue?vue&type=style&index=0&id=06bc9820&scoped=true&lang=css"

import exportComponent from "/home/accesa/Documents/ACCESA/DANA_PROJECTS/DANA-LITE/dana-lite-registro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bc9820"]])

export default __exports__